import { httpClient } from '../client';
import { ServiceResourceMapping } from '../../../types/service';
import { logger } from '../../../utils/logger';
import { BaseEndpoint } from './base.endpoint';

class ServiceMappingEndpoints extends BaseEndpoint {
  private static instance: ServiceMappingEndpoints;

  private constructor() {
    super('organisations');
  }

  static getInstance(): ServiceMappingEndpoints {
    if (!ServiceMappingEndpoints.instance) {
      ServiceMappingEndpoints.instance = new ServiceMappingEndpoints();
    }
    return ServiceMappingEndpoints.instance;
  }

  async createMapping(organizationId: string, serviceId: number, resourceId: number) {
    try {
      const headers = await this.getAuthHeaders();
      const response = await httpClient.post<{ data: ServiceResourceMapping }>(
        `${this.basePath}/${organizationId}/servicemapping`,
        { serviceId, resourceId },
        { headers }
      );

      logger.info('Service mapping created successfully');
      return response.data.data;
    } catch (error) {
      logger.error('Failed to create service mapping:', error);
      throw error;
    }
  }

  async deleteMapping(organizationId: string, mappingId: number) {
    try {
      const headers = await this.getAuthHeaders();
      await httpClient.delete(`${this.basePath}/${organizationId}/servicemapping/${mappingId}`, {
        headers,
      });

      logger.info('Service mapping deleted successfully');
    } catch (error) {
      logger.error('Failed to delete service mapping:', error);
      throw error;
    }
  }
}

export const serviceMappingEndpoints = ServiceMappingEndpoints.getInstance();
